import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

 const Topical = (props) => (
   <SvgIcon {...props}>
        <polygon fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
            16.333,15 6.333,15 7.333,22 15.333,22 "/>
        <rect x="5.333" y="12.667" fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" width="12" height="2.333"/>
        <polyline fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
            10.333,12.667 14.333,3 15.333,9.667 "/>
        <polyline fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
            13,12.667 17.667,6.667 16.667,12.667 "/>
        <polyline fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
            12,8.667 9,2 8,10.333 "/>
        <polyline fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
            9.667,12.667 4.333,5.333 6.333,12.667 "/>
   </SvgIcon>
);

export default Topical;



// WEBPACK FOOTER //
// ./src/icons/types/Plant.jsx